import React from 'react';

/**
 * Cursor-based pagination component.
 *
 * Props:
 * - hasMore: boolean  - whether there are more items after the current page
 * - onNext: () => void - called when user clicks "Next"
 * - onPrev: () => void - called when user clicks "Previous" (optional)
 * - hasPrev: boolean   - whether previous page exists (optional)
 * - loading: boolean   - disable buttons while loading
 */
export default function Pagination({ hasMore, onNext, onPrev, hasPrev, loading }) {
  return (
    <div className="d-flex justify-content-end align-items-center py-3 gap-2">
      {onPrev && (
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={onPrev}
          disabled={loading || !hasPrev}
        >
          &laquo; Previous
        </button>
      )}
      <button
        type="button"
        className="btn btn-outline-secondary btn-sm"
        onClick={onNext}
        disabled={loading || !hasMore}
      >
        Next &raquo;
      </button>
    </div>
  );
}
